// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/bg-gas.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27%3E%3Cpath d=%27M7 10L12 15L17 10%27 stroke=%27%23DD1D20%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --shell-green: #00854e;
  --shell-yellow: #f8cd05;
  --shell-red: #dd1d20;
  --text-dark: #3b3b3b;
  --text-light: #ffffff;
  --transition-speed: 0.3s;
  --default-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Ubuntu, "Helvetica Neue", Helvetica, Arial, "PingFang SC",
    "Hiragino Sans GB", "Microsoft Yahei UI", "Microsoft Yahei",
    "Source Han Sans CN", sans-serif;
}

/* Accessibility helper classes */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Gas Form Component - Main Container */
.gas-form {
  width: 100%;
  max-width: 100%;
  font-family: ShellBook, var(--default-font-family);
}

.gas-form * {
  box-sizing: border-box;
}

.gas-form-main-container {
  position: relative;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 55px;
}

/* Gas Stations Container */
.gas-form-stations-container {
  position: relative;
  width: 100%;
  height: 520px;
}

/* Background Elements */
.gas-form-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.gas-form-bg-image {
  position: relative;
  width: 100%;
  height: calc(100% - 16px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
  z-index: 1;
  border-radius: 50px;
  overflow: hidden;
}

.gas-form-bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(59, 59, 59, 0.7); /* #3B3B3B com 70% de opacidade */
  z-index: 2;
}

.gas-form-line-red-container {
  position: relative;
  width: 92%;
  max-width: 1180px;
  height: 16px;
  margin: 0 auto;
  z-index: 2;
}

.gas-form-line-red {
  position: relative;
  width: 100%;
  height: 8px;
  background: var(--shell-red);
  border-radius: 0 0 50px 50px;
  z-index: 2;
}

.gas-form-line-green {
  position: relative;
  width: 88%;
  max-width: 1130px;
  height: 8px;
  margin: 0 auto;
  background: var(--shell-green);
  border-radius: 0 0 50px 50px;
  z-index: 3;
  display: block; /* Ensure the element is displayed */
  top: -4px; /* Adjust position to make it visible below the red line */
}
/* Form Menu */
.gas-form-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px 0;
  z-index: 10;
}

/* Dropdowns Group */
.gas-form-dropdowns-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  max-width: 700px;
  z-index: 7;
}

/* Form Field Styles */
.gas-form-field-container {
  width: calc(33.33% - 11px);
  min-width: 180px;
  position: relative;
}

.gas-form-label {
  display: block;
  margin-bottom: 5px;
  color: var(--text-dark);
  font-family: ShellMedium, var(--default-font-family);
  font-size: 14px;
}

.gas-form-select {
  display: block;
  width: 100%;
  height: 48px;
  padding: 12px 18px;
  padding-right: 40px; /* Space for the dropdown arrow */
  background: #ffffff;
  border: 2px solid var(--shell-red);
  border-radius: 8px;
  color: var(--shell-red);
  font-family: ShellMedium, var(--default-font-family);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  appearance: none; /* Remove default arrow */
  cursor: pointer;
  transition: all var(--transition-speed) ease;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 24px;
}

.gas-form-select:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.gas-form-select:focus {
  outline: 2px solid var(--shell-yellow);
  outline-offset: 1px;
}

.gas-form-select:disabled {
  border-color: var(--color-contrast-dark-red);
  color: var(--color-contrast-dark-red);
  opacity: 0.7;
  cursor: not-allowed;
  background-color: #f5f5f5;
}
/* Button Styles */
.gas-form-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 260px;
  padding: 14px 20px;
  background: var(--shell-red);
  border: 1.5px solid var(--shell-red);
  border-radius: 8px;
  color: var(--text-light);
  font-family: ShellMedium, var(--default-font-family);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  transition: all var(--transition-speed) ease;
}

.gas-form-button:hover {
  background-color: #b51819;
}

.gas-form-button:focus {
  outline: 2px solid var(--shell-yellow);
  outline-offset: 2px;
}

.gas-form-button:active {
  transform: translateY(1px);
}

.gas-form-button-text {
  color: inherit;
}
/* Gas Station Results */
.gas-form-results {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding: 20px;
  z-index: 10;
  position: relative;
}

/* .gas-form-results-title removido conforme solicitado */

.gas-form-results-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-height: 260px; /* Limite de altura para desktop */
  overflow-y: auto; /* Habilita scroll vertical */
  scrollbar-width: thin;
  scrollbar-color: var(--shell-yellow) var(--color-primary-light-gray);
  scroll-behavior: smooth;
}

/* Estilização da barra de rolagem para Webkit (Chrome, Safari, etc) */
.gas-form-results-list::-webkit-scrollbar {
  width: 6px;
}

.gas-form-results-list::-webkit-scrollbar-track {
  background: var(--color-primary-light-gray);
  border-radius: 20px;
}

.gas-form-results-list::-webkit-scrollbar-thumb {
  background-color: var(--shell-yellow);
  border-radius: 20px;
}

.gas-form-result-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 10px;
  border-bottom: 1.5px solid rgba(255, 255, 255, 0.10);
  position: relative;
}

.gas-form-result-logo {
  flex-shrink: 0;
  width: 50px;
  height: 47px;
  margin-right: 20px;
}

.gas-form-result-info {
  flex-grow: 0;
  max-width: 600px; /* Limitando a largura conforme solicitado */
  margin-right: 20px;
}

.gas-form-result-name {
  color: var(--Shell-Color-White, #FFF);
  font-family: ShellHeavy, var(--default-font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  margin-bottom: 4px;
}

.gas-form-result-address {
  color: var(--Shell-Color-White, #FFF);
  font-family: ShellBook, var(--default-font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  margin-bottom: 8px;
}

.gas-form-result-map-button {
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1.5px solid var(--Shell-Color-White, #FFF);
  color: var(--Shell-Color-White, #FFF);
  text-align: center;
  font-family: ShellMedium, var(--default-font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration: none;
  transition: all var(--transition-speed) ease;
}

.gas-form-result-map-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.gas-form-no-results {
  color: var(--text-light, #FFF);
  font-family: ShellBook, var(--default-font-family);
  font-size: 18px;
  line-height: 160%;
  text-align: center;
  padding: 40px 0;
}

/* Botão Carregar Mais */
.gas-form-load-more {
  display: none; /* Escondido por padrão no desktop */
  width: 100%;
  padding: 12px 24px;
  margin-top: 20px;
  background-color: transparent;
  color: var(--text-light, #FFF);
  border: 1.5px solid var(--text-light, #FFF);
  border-radius: 8px;
  font-family: ShellMedium, var(--default-font-family);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  transition: all var(--transition-speed) ease;
}

.gas-form-load-more:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Responsive Styles */
@media (max-width: 992px) {
  .gas-form-container {
    padding: 0 15px;
  }
  
  .gas-form-title {
    font-size: 30px;
  }
  
  .gas-form-description {
    font-size: 16px;
  }
  
  .gas-form-stations-container {
    height: auto;
    min-height: 500px;
  }
  
  .gas-form-menu {
    padding: 30px 15px 0;
  }
  
  .gas-form-field-container {
    width: calc(50% - 8px);
  }
  
  .gas-form-field-container:last-child {
    width: 100%;
  }
}

@media (max-width: 768px) {
  /* Removendo o scroll para mobile e tablet */
  .gas-form-results-list {
    max-height: none;
    overflow-y: visible;
  }
  
  /* Exibindo o botão carregar mais em mobile e tablet */
  .gas-form-load-more {
    display: block;
  }
  
  /* Ajustando o layout do item de resultado para mobile */
  .gas-form-result-item {
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 20px;
  }
  
  /* Mantendo a logo ao lado das informações no mobile */
  .gas-form-result-item > div:first-child {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 12px;
  }
  
  /* Ajustando o espaçamento do logo para mobile */
  .gas-form-result-logo {
    margin-bottom: 0;
    margin-right: 16px;
  }
  
  /* Ajustando o container de informações para mobile */
  .gas-form-result-info {
    margin-right: 0;
    margin-bottom: 0;
    flex: 1;
  }
  
  /* Ajustando o estilo do nome do posto para mobile */
  .gas-form-result-name {
    color: var(--Shell-Color-White, #FFF);
    font-family: ShellMedium, var(--default-font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%; /* 17.6px */
  }
  
  /* Ajustando o estilo do endereço do posto para mobile */
  .gas-form-result-address {
    color: var(--Shell-Color-White, #FFF);
    font-family: ShellBook, var(--default-font-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  }
  
  /* Ajustando o botão de mapa para mobile */
  .gas-form-result-map-button {
    display: inline;
    padding: 0;
    margin-left: 0;
    width: auto;
    color: var(--Shell-Color-Light-Yellow, #F8CD05);
    font-family: ShellMedium, var(--default-font-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 19.6px */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    background: transparent;
    border: none;
  }
  
  /* Adicionando botão de voltar para o formulário no mobile */
  .gas-form-back-button {
    display: none; /* Escondido por padrão em todos os dispositivos */
    align-items: center;
    color: var(--Shell-Color-White, #FFF);
    font-family: ShellMedium, var(--default-font-family);
    font-size: 16px;
    font-weight: 500;
    margin: 30px 20px 0;
    cursor: pointer;
    position: relative;
  }
  
  /* Garantir que o botão nunca seja exibido em desktop */
  @media (min-width: 769px) {
    .gas-form-back-button,
    .gas-form-back-button-visible {
      display: none !important; /* Força a não exibição em desktop */
      pointer-events: none;
    }
  }
  
  .gas-form-back-button svg {
    margin-right: 8px;
  }
  
  /* Escondendo o formulário quando há resultados no mobile */
  .gas-form-menu-hidden {
    display: none;
  }
  
  /* Classe para exibir o botão apenas em dispositivos móveis */
  .gas-form-back-button-visible {
    display: flex;
  }
  
  /* Versão mobile apenas */
  @media (max-width: 768px) {
    .gas-form-back-button-visible {
      display: flex;
    }
  }
  
  .gas-form-title {
    font-size: 26px;
  }
  
  .gas-form-description {
    font-size: 14px;
    white-space: normal;
  }
  
  .gas-form-bg-image {
    height: calc(100% - 12px);
    border-radius: 24px;
  }
  
  .gas-form-line-red-container,
  .gas-form-line-green {
    height: 4px;
  }

  .gas-form-line-red-container {
    width: 88%;
  }
  
  .gas-form-line-red {
    height: 4px;
  }

  .gas-form-line-green {
    width: 80%;
    top: 2px;
  }
  
  .gas-form-menu {
    flex-direction: column;
    align-items: stretch;
  }
  
  .gas-form-field-container {
    width: 100%;
    margin-bottom: 12px;
  }
  
  .gas-form-button {
    width: 100%;
    margin-top: 10px;
  }
  
  /* Improve touch target sizes on mobile */
  .gas-form-select,
  .gas-form-button {
    min-height: 52px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scripts/components/gasStations/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB;;;oCAGkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,oEAA2D;EAC3D,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC,EAAE,iCAAiC;EAC1E,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,4BAA4B;EAC5B,UAAU;EACV,cAAc,EAAE,oCAAoC;EACpD,SAAS,EAAE,0DAA0D;AACvE;AACA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAE,iCAAiC;EACtD,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB,EAAE,yBAAyB;EAC3C,eAAe;EACf,4CAA4C;EAC5C,yDAA6Q;EAC7Q,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;AACA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB,EAAE,kCAAkC;EACrD,gBAAgB,EAAE,6BAA6B;EAC/C,qBAAqB;EACrB,oEAAoE;EACpE,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB,EAAE,4CAA4C;EAC9D,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mDAAmD;EACnD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kDAAkD;EAClD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;EAClD,qCAAqC;EACrC,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,kDAAkD;EAClD,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa,EAAE,oCAAoC;EACnD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,4CAA4C;EAC5C;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,sDAAsD;EACtD;IACE,cAAc;EAChB;;EAEA,wDAAwD;EACxD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA,sDAAsD;EACtD;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;EACrB;;EAEA,gDAAgD;EAChD;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,qDAAqD;EACrD;IACE,eAAe;IACf,gBAAgB;IAChB,OAAO;EACT;;EAEA,oDAAoD;EACpD;IACE,qCAAqC;IACrC,oDAAoD;IACpD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;EAChC;;EAEA,wDAAwD;EACxD;IACE,qCAAqC;IACrC,kDAAkD;IAClD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;EAChC;;EAEA,0CAA0C;EAC1C;IACE,eAAe;IACf,UAAU;IACV,cAAc;IACd,WAAW;IACX,+CAA+C;IAC/C,oDAAoD;IACpD,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;IAC9B,+BAA+B;IAC/B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;IAC3B,kCAAkC;IAClC,uBAAuB;IACvB,YAAY;EACd;;EAEA,4DAA4D;EAC5D;IACE,aAAa,EAAE,kDAAkD;IACjE,mBAAmB;IACnB,qCAAqC;IACrC,oDAAoD;IACpD,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA,uDAAuD;EACvD;IACE;;MAEE,wBAAwB,EAAE,oCAAoC;MAC9D,oBAAoB;IACtB;EACF;;EAEA;IACE,iBAAiB;EACnB;;EAEA,2DAA2D;EAC3D;IACE,aAAa;EACf;;EAEA,6DAA6D;EAC7D;IACE,aAAa;EACf;;EAEA,yBAAyB;EACzB;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,yCAAyC;EACzC;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[":root {\n  --shell-green: #00854e;\n  --shell-yellow: #f8cd05;\n  --shell-red: #dd1d20;\n  --text-dark: #3b3b3b;\n  --text-light: #ffffff;\n  --transition-speed: 0.3s;\n  --default-font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Ubuntu, \"Helvetica Neue\", Helvetica, Arial, \"PingFang SC\",\n    \"Hiragino Sans GB\", \"Microsoft Yahei UI\", \"Microsoft Yahei\",\n    \"Source Han Sans CN\", sans-serif;\n}\n\n/* Accessibility helper classes */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Gas Form Component - Main Container */\n.gas-form {\n  width: 100%;\n  max-width: 100%;\n  font-family: ShellBook, var(--default-font-family);\n}\n\n.gas-form * {\n  box-sizing: border-box;\n}\n\n.gas-form-main-container {\n  position: relative;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 55px;\n}\n\n/* Gas Stations Container */\n.gas-form-stations-container {\n  position: relative;\n  width: 100%;\n  height: 520px;\n}\n\n/* Background Elements */\n.gas-form-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n.gas-form-bg-image {\n  position: relative;\n  width: 100%;\n  height: calc(100% - 16px);\n  background: url(/public/images/bg-gas.jpg) no-repeat center;\n  background-size: cover;\n  z-index: 1;\n  border-radius: 50px;\n  overflow: hidden;\n}\n\n.gas-form-bg-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(59, 59, 59, 0.7); /* #3B3B3B com 70% de opacidade */\n  z-index: 2;\n}\n\n.gas-form-line-red-container {\n  position: relative;\n  width: 92%;\n  max-width: 1180px;\n  height: 16px;\n  margin: 0 auto;\n  z-index: 2;\n}\n\n.gas-form-line-red {\n  position: relative;\n  width: 100%;\n  height: 8px;\n  background: var(--shell-red);\n  border-radius: 0 0 50px 50px;\n  z-index: 2;\n}\n\n.gas-form-line-green {\n  position: relative;\n  width: 88%;\n  max-width: 1130px;\n  height: 8px;\n  margin: 0 auto;\n  background: var(--shell-green);\n  border-radius: 0 0 50px 50px;\n  z-index: 3;\n  display: block; /* Ensure the element is displayed */\n  top: -4px; /* Adjust position to make it visible below the red line */\n}\n/* Form Menu */\n.gas-form-menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  position: relative;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px 0;\n  z-index: 10;\n}\n\n/* Dropdowns Group */\n.gas-form-dropdowns-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  width: 100%;\n  max-width: 700px;\n  z-index: 7;\n}\n\n/* Form Field Styles */\n.gas-form-field-container {\n  width: calc(33.33% - 11px);\n  min-width: 180px;\n  position: relative;\n}\n\n.gas-form-label {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--text-dark);\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 14px;\n}\n\n.gas-form-select {\n  display: block;\n  width: 100%;\n  height: 48px;\n  padding: 12px 18px;\n  padding-right: 40px; /* Space for the dropdown arrow */\n  background: #ffffff;\n  border: 2px solid var(--shell-red);\n  border-radius: 8px;\n  color: var(--shell-red);\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  appearance: none; /* Remove default arrow */\n  cursor: pointer;\n  transition: all var(--transition-speed) ease;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M7 10L12 15L17 10' stroke='%23DD1D20' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 24px;\n}\n\n.gas-form-select:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.gas-form-select:focus {\n  outline: 2px solid var(--shell-yellow);\n  outline-offset: 1px;\n}\n\n.gas-form-select:disabled {\n  border-color: var(--color-contrast-dark-red);\n  color: var(--color-contrast-dark-red);\n  opacity: 0.7;\n  cursor: not-allowed;\n  background-color: #f5f5f5;\n}\n/* Button Styles */\n.gas-form-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 260px;\n  padding: 14px 20px;\n  background: var(--shell-red);\n  border: 1.5px solid var(--shell-red);\n  border-radius: 8px;\n  color: var(--text-light);\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all var(--transition-speed) ease;\n}\n\n.gas-form-button:hover {\n  background-color: #b51819;\n}\n\n.gas-form-button:focus {\n  outline: 2px solid var(--shell-yellow);\n  outline-offset: 2px;\n}\n\n.gas-form-button:active {\n  transform: translateY(1px);\n}\n\n.gas-form-button-text {\n  color: inherit;\n}\n/* Gas Station Results */\n.gas-form-results {\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 20px;\n  z-index: 10;\n  position: relative;\n}\n\n/* .gas-form-results-title removido conforme solicitado */\n\n.gas-form-results-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  max-height: 260px; /* Limite de altura para desktop */\n  overflow-y: auto; /* Habilita scroll vertical */\n  scrollbar-width: thin;\n  scrollbar-color: var(--shell-yellow) var(--color-primary-light-gray);\n  scroll-behavior: smooth;\n}\n\n/* Estilização da barra de rolagem para Webkit (Chrome, Safari, etc) */\n.gas-form-results-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.gas-form-results-list::-webkit-scrollbar-track {\n  background: var(--color-primary-light-gray);\n  border-radius: 20px;\n}\n\n.gas-form-results-list::-webkit-scrollbar-thumb {\n  background-color: var(--shell-yellow);\n  border-radius: 20px;\n}\n\n.gas-form-result-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-bottom: 10px;\n  border-bottom: 1.5px solid rgba(255, 255, 255, 0.10);\n  position: relative;\n}\n\n.gas-form-result-logo {\n  flex-shrink: 0;\n  width: 50px;\n  height: 47px;\n  margin-right: 20px;\n}\n\n.gas-form-result-info {\n  flex-grow: 0;\n  max-width: 600px; /* Limitando a largura conforme solicitado */\n  margin-right: 20px;\n}\n\n.gas-form-result-name {\n  color: var(--Shell-Color-White, #FFF);\n  font-family: ShellHeavy, var(--default-font-family);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 160%;\n  margin-bottom: 4px;\n}\n\n.gas-form-result-address {\n  color: var(--Shell-Color-White, #FFF);\n  font-family: ShellBook, var(--default-font-family);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  margin-bottom: 8px;\n}\n\n.gas-form-result-map-button {\n  display: flex;\n  padding: 8px 12px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  border: 1.5px solid var(--Shell-Color-White, #FFF);\n  color: var(--Shell-Color-White, #FFF);\n  text-align: center;\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  text-decoration: none;\n  transition: all var(--transition-speed) ease;\n}\n\n.gas-form-result-map-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.gas-form-no-results {\n  color: var(--text-light, #FFF);\n  font-family: ShellBook, var(--default-font-family);\n  font-size: 18px;\n  line-height: 160%;\n  text-align: center;\n  padding: 40px 0;\n}\n\n/* Botão Carregar Mais */\n.gas-form-load-more {\n  display: none; /* Escondido por padrão no desktop */\n  width: 100%;\n  padding: 12px 24px;\n  margin-top: 20px;\n  background-color: transparent;\n  color: var(--text-light, #FFF);\n  border: 1.5px solid var(--text-light, #FFF);\n  border-radius: 8px;\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition-speed) ease;\n}\n\n.gas-form-load-more:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Responsive Styles */\n@media (max-width: 992px) {\n  .gas-form-container {\n    padding: 0 15px;\n  }\n  \n  .gas-form-title {\n    font-size: 30px;\n  }\n  \n  .gas-form-description {\n    font-size: 16px;\n  }\n  \n  .gas-form-stations-container {\n    height: auto;\n    min-height: 500px;\n  }\n  \n  .gas-form-menu {\n    padding: 30px 15px 0;\n  }\n  \n  .gas-form-field-container {\n    width: calc(50% - 8px);\n  }\n  \n  .gas-form-field-container:last-child {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  /* Removendo o scroll para mobile e tablet */\n  .gas-form-results-list {\n    max-height: none;\n    overflow-y: visible;\n  }\n  \n  /* Exibindo o botão carregar mais em mobile e tablet */\n  .gas-form-load-more {\n    display: block;\n  }\n  \n  /* Ajustando o layout do item de resultado para mobile */\n  .gas-form-result-item {\n    flex-direction: column;\n    align-items: flex-start;\n    padding-bottom: 20px;\n  }\n  \n  /* Mantendo a logo ao lado das informações no mobile */\n  .gas-form-result-item > div:first-child {\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n    margin-bottom: 12px;\n  }\n  \n  /* Ajustando o espaçamento do logo para mobile */\n  .gas-form-result-logo {\n    margin-bottom: 0;\n    margin-right: 16px;\n  }\n  \n  /* Ajustando o container de informações para mobile */\n  .gas-form-result-info {\n    margin-right: 0;\n    margin-bottom: 0;\n    flex: 1;\n  }\n  \n  /* Ajustando o estilo do nome do posto para mobile */\n  .gas-form-result-name {\n    color: var(--Shell-Color-White, #FFF);\n    font-family: ShellMedium, var(--default-font-family);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 110%; /* 17.6px */\n  }\n  \n  /* Ajustando o estilo do endereço do posto para mobile */\n  .gas-form-result-address {\n    color: var(--Shell-Color-White, #FFF);\n    font-family: ShellBook, var(--default-font-family);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 140%; /* 19.6px */\n  }\n  \n  /* Ajustando o botão de mapa para mobile */\n  .gas-form-result-map-button {\n    display: inline;\n    padding: 0;\n    margin-left: 0;\n    width: auto;\n    color: var(--Shell-Color-Light-Yellow, #F8CD05);\n    font-family: ShellMedium, var(--default-font-family);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 140%; /* 19.6px */\n    text-decoration-line: underline;\n    text-decoration-style: solid;\n    text-decoration-skip-ink: none;\n    text-decoration-thickness: auto;\n    text-underline-offset: auto;\n    text-underline-position: from-font;\n    background: transparent;\n    border: none;\n  }\n  \n  /* Adicionando botão de voltar para o formulário no mobile */\n  .gas-form-back-button {\n    display: none; /* Escondido por padrão em todos os dispositivos */\n    align-items: center;\n    color: var(--Shell-Color-White, #FFF);\n    font-family: ShellMedium, var(--default-font-family);\n    font-size: 16px;\n    font-weight: 500;\n    margin: 30px 20px 0;\n    cursor: pointer;\n    position: relative;\n  }\n  \n  /* Garantir que o botão nunca seja exibido em desktop */\n  @media (min-width: 769px) {\n    .gas-form-back-button,\n    .gas-form-back-button-visible {\n      display: none !important; /* Força a não exibição em desktop */\n      pointer-events: none;\n    }\n  }\n  \n  .gas-form-back-button svg {\n    margin-right: 8px;\n  }\n  \n  /* Escondendo o formulário quando há resultados no mobile */\n  .gas-form-menu-hidden {\n    display: none;\n  }\n  \n  /* Classe para exibir o botão apenas em dispositivos móveis */\n  .gas-form-back-button-visible {\n    display: flex;\n  }\n  \n  /* Versão mobile apenas */\n  @media (max-width: 768px) {\n    .gas-form-back-button-visible {\n      display: flex;\n    }\n  }\n  \n  .gas-form-title {\n    font-size: 26px;\n  }\n  \n  .gas-form-description {\n    font-size: 14px;\n    white-space: normal;\n  }\n  \n  .gas-form-bg-image {\n    height: calc(100% - 12px);\n    border-radius: 24px;\n  }\n  \n  .gas-form-line-red-container,\n  .gas-form-line-green {\n    height: 4px;\n  }\n\n  .gas-form-line-red-container {\n    width: 88%;\n  }\n  \n  .gas-form-line-red {\n    height: 4px;\n  }\n\n  .gas-form-line-green {\n    width: 80%;\n    top: 2px;\n  }\n  \n  .gas-form-menu {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .gas-form-field-container {\n    width: 100%;\n    margin-bottom: 12px;\n  }\n  \n  .gas-form-button {\n    width: 100%;\n    margin-top: 10px;\n  }\n  \n  /* Improve touch target sizes on mobile */\n  .gas-form-select,\n  .gas-form-button {\n    min-height: 52px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
